import React from 'react';

import BuilderComponent from 'components/BuilderComponent/BuilderComponent';
import { Wrapper } from 'components/Layout/Layout';

export default function BlackFridayPage() {
  return (
    <Wrapper>
      <BuilderComponent
        entries={{
          de: '773592ef5e274ca997448e9c44962fd0',
          en: '773592ef5e274ca997448e9c44962fd0',
          sv: '773592ef5e274ca997448e9c44962fd0',
        }}
      />
    </Wrapper>
  );
}
